import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import Products from './products/products';
import Categories from './categories/categories';
import Cartable from './cartable/cartable';
import Dashboard from './dashboard/dashboard';
import Orders from './orders/orders';
import Desktop from './desktop/desktop';
import Users from './users/users';
import BroadCast from './broadcast/broadcast';
import Contract from './contract/contract';

const toliton = (props) => {
    var match = props.match;
    return (
        <div className="app-wrapper">
            <Switch>
                <Redirect exact from={`${match.url}/`} to={`${match.url}/dashboard`}/>
                <Route path={`${match.url}/dashboard`} render={() => (<Dashboard {...props}/>)}/>
                <Route path={`${match.url}/desktop`} render={() => (<Desktop {...props}/>)}/>
                <Route path={`${match.url}/products`} render={() => (<Products {...props}/>)}/>
                <Route path={`${match.url}/categories`} render={() => (<Categories {...props}/>)}/>
                <Route path={`${match.url}/cartable`} render={() => (<Cartable {...props}/>)}/>
                <Route path={`${match.url}/orders`} render={() => (<Orders {...props}/>)}/>
                <Route path={`${match.url}/users`} render={() => (<Users {...props}/>)}/>
                <Route path={`${match.url}/broadcast`} render={() => (<BroadCast {...props}/>)}/>
                <Route path={`${match.url}/broadcast`} render={() => (<BroadCast {...props}/>)}/>
                <Route path={`${match.url}/contract`} render={() => (<Contract {...props}/>)}/>
            </Switch>
        </div>
    );

}
export default toliton;



// WEBPACK FOOTER //
// ./app/routes/toliton/index.js